import {
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  Faro
} from "@grafana/faro-react";
import { EmptyObject } from "lodash-es";
import isEmpty from "lodash/isEmpty";
import { ISession } from '@opengov/app-core/types';

// Tracks whether Faro was actually enabled once session.environment is known.
// null = initialize() not yet called (pre-session); true/false = set by initialize().
let _enabled: boolean | null = null;

export function initialize(session: ISession) {
  if (process.env.NODE_ENV !== 'production') {
    _enabled = false;
    return;
  }
  if (!['production', 'staging'].includes(session.environment)) {
    _enabled = false;
    return;
  }

  try {
    const appVersion = window.process.env.GITHUB_SHA;
    // eslint-disable-next-line no-console
    console.log('stories_app_version:', appVersion);
    const result = initializeFaro({
      url: 'https://faro-collector-prod-us-central-0.grafana.net/collect/fda73ccfc7dbd695819fc1eccabc289a',
      app: {
        name: 'bnp-stories-frontend',
        version: appVersion,
        environment: session.environment
      },
      sessionTracking: {
        samplingRate: session.environment === 'production' ? 0.1 : 0.05
      },
      user: {
        email: session.email,

        attributes: {
          uuid: session.uuid,
          title: session.title,
          department: session.department,
          first_name: session.first_name,
          last_name: session.last_name,
          full_name: session.full_name,
          role_name: session.role?.name,
          entity_id: session.entity?.id,
          entity_name: session.entity?.name,
          entity_uuid: session.entity?.uuid
        }
      },
      instrumentations: [...getWebInstrumentations(), new ReactIntegration()]
    });
    _enabled = true;
    return result;
  } catch (error) {
    console.error('Failed to initialize Grafana Faro:', error);
    _enabled = false;
    return null;
  }
}

export function isClientInitialized(faro: Faro | EmptyObject<Faro>) {
  return !isEmpty(faro) && faro.api !== undefined;
}

// Returns true when Faro is (or will be) active in this session.
// Pre-session: falls back to NODE_ENV check (consistent with pre-existing behaviour).
// Post-session: reflects the actual decision made by initialize().
export function shouldFaroBeEnabled() {
  if (_enabled !== null) return _enabled;
  return process.env.NODE_ENV === 'production';
}
